var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Grid',{ref:"modalzonesGrid",attrs:{"name":"modalzonesGrid","url":_vm.url,"columns":_vm.columns,"pageable":true,"height":_vm.height,"filterable":true,"sortable":true,"schemaModelFields":_vm.schemaModelFields,"preload":_vm.preload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }